import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AttributeToStringPipe } from 'ish-core/models/attribute/attribute.pipe';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

@Component({
  selector: 'ish-product-attributes',
  templateUrl: './product-attributes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AttributeToStringPipe, CommonModule],
})
export class ProductAttributesComponent {
  readonly product = input.required<ProductView>();
  readonly multipleValuesSeparator = input(', ');
}
